import { BuildingType, CustomerType, ServiceType } from "./customer.model";

export class Tariff {
    id: number;
    name: string;
    class: string;
    rate: number | undefined;
    utilityId: number;
    serviceTypes?: ServiceType[] = [];
    customerTypes?: CustomerType[] = [];
    useOfPremises?: BuildingType[] = [];
    currentServiceTypes?: string;
    currentCustomerTypes?: string;
    currentUseOfPremises?: string;
    sltStatusId?: number
}

export function getInitTariff(): Tariff{
    return {
        id: 0,
        name: '',
        class: '',
        rate: undefined,
        utilityId: 0,
        currentCustomerTypes: '',
        currentServiceTypes: '',
        currentUseOfPremises: ''
    }
}